<template>
  <div class="background-01">
    <v-layout row wrap>
      <v-flex xs12 sm2 text-xs-right class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="100" imaSrc="design/gray-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm10 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Una buena práctica para administrar el dinero es realizar el flujo de efectivo, pero…" titleLevel="h1">
          <template slot="partOne">Una buena práctica para </template>
          <template slot="partTwo"> administrar el dinero es realizar el </template>
          <template slot="partThree">flujo de efectivo, pero…</template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Qué es un flujo de efectivo?'" videoEmbed="ADMINISTRACIONDINERO13FlujoDedEfectivo(ant44).mp4"></ui-simple-lsc>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-1 justify-center class="animated rotateInUpLeft dura_2">
      <v-flex xs12 sm9>
        <h2 class="app-title font-red ">¿Qué es un flujo de efectivo?</h2>
      </v-flex>
      <v-flex xs12 sm8 mt-3 class="adorn-bottom" mb-5>
        <p>
          Es un <strong>plan detallado</strong> de ingresos  y egresos que permite  conocer la situación financiera y realizar 
          ajustes en la medida que sean necesarios.<br><br>
          
          La mayoría de personas normalmente no piensa en el flujo  de efectivo en términos de <strong>ingresos y gastos,</strong> 
          de hecho se cree que este solo es importante para los negocios;  sin embargo, 
          cada persona tiene uno propio, y determinar si es positivo o negativo, es <strong>vital</strong> para la 
          administración del dinero.
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-13.vue?fa8a7f7a